import CardGraph from "./components/CardGraph.js";
import CardImage from "./components/CardImage.js";
import CardLink from "./components/CardLink.js";
import CardWidget from "./components/CardWidget.js";
import CardsContainer from "./components/CardsContainer.js";
import CardsFromSet from "./components/CardsFromSet.js";
import DeckSampleHand from "./components/DeckSampleHand.js";
import DeckStatsColors from "./components/DeckStatsColors.js";
import DeckStatsManaValues from "./components/DeckStatsManaValues.js";
import DeckStatsTypes from "./components/DeckStatsTypes.js";
// import GradedCardListings from "./components/GradedCardListings.js";
import PriceBoxes from "./components/PriceBoxes.js";
import TierList from "./components/TierList.js";

export default {
  CardGraph,
  CardImage,
  CardLink,
  CardWidget,
  CardsContainer,
  CardsFromSet,
  DeckSampleHand,
  DeckStatsColors,
  DeckStatsManaValues,
  DeckStatsTypes,
  // GradedCardListings,
  PriceBoxes,
  TierList,
};

// need to do this so the names still resolved after --minify
window.CardGraph = CardGraph
window.CardImage = CardImage
window.CardLink = CardLink
window.CardWidget = CardWidget
window.CardsContainer = CardsContainer
window.CardsFromSet = CardsFromSet
window.DeckSampleHand = DeckSampleHand
window.DeckStatsColors = DeckStatsColors
window.DeckStatsManaValues = DeckStatsManaValues
window.DeckStatsTypes = DeckStatsTypes
// window.GradedCardListings = GradedCardListings
window.PriceBoxes = PriceBoxes
window.TierList = TierList
